import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ceres-settings-custom-filter-save-dialog',
    templateUrl: './custom-filter-save-dialog.component.html',
    styleUrls: ['./custom-filter-save-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomFilterSaveDialogComponent {
    private dialogRef = inject<MatDialogRef<CustomFilterSaveDialogComponent>>(MatDialogRef);

    public name: string;

    public cancel() {
        this.dialogRef.close();
    }

    public confirm() {
        this.dialogRef.close(this.name);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.dialogRef.close();
    }

    onNameChange(value: string): void {
        this.name = value;
    }
}
